import { lazy } from "react";

// Retries a dynamic import a few times before giving up — protects
// against a stale deployed chunk hash (common right after a new deploy)
// causing a hard "ChunkLoadError" for users with the old page still open.
export function lazyWithRetry(importFn, retries = 3, delay = 800) {
  return lazy(() =>
    new Promise((resolve, reject) => {
      const attempt = (n) => {
        importFn()
          .then(resolve)
          .catch((err) => {
            if (n <= 0) return reject(err);
            setTimeout(() => attempt(n - 1), delay);
          });
      };
      attempt(retries);
    }),
  );
}
